import jQuery from 'jquery';
import 'jquery.easing';
import SpMenuButton from './modules/SpMenuButton';
import MouseStalker from './modules/MouseStalker';
import Loader from './modules/Loader';
import Header from './modules/Header';
import StickyFooter from './modules/StickyFooter';
// import CanvasOverlay from './modules/CanvasOverlay';
import ScrollEffectManager from './modules/ScrollEffectManager';
import ScrollImageManager from './modules/ScrollImageManager';
import PageHome from './modules/PageHome';
import PageContact from './modules/PageContact';
import PageThanks from './modules/PageThanks';
import PageWorksDetail from './modules/PageWorksDetail';
import PageService from './modules/PageService';
import Router from './modules/router';
import PageValue from './modules/PageValue';
import PageNews from './modules/PageNews';
import PageCulture from './modules/PageCulture';
import PageDmcDetail from './modules/PageDmcDetail';
import PageBrand from './modules/PageBrand';
import PagePeople from './modules/PagePeople';
import MainMenu from './modules/MainMenu';

const $ = jQuery;
window.jQuery = $;
window.$ = $;
window.onLoadComplete = false;

class MainApp {
  constructor() {
    this.pageApp = undefined;
    this.router = new Router(this);
    this.$window = $(window);
    this.windowH = this.$window.height();
    this.header = new Header();
    this.stickyFooter = new StickyFooter(getNamespace());
    this.menu = new MainMenu();
    // new Loader();
    new SpMenuButton();

    this.scrollEffectManager = new ScrollEffectManager();
    this.scrollImageManager = new ScrollImageManager();

    if (sessionStorage.getItem('history')) {
      const historyAry = JSON.parse(sessionStorage.getItem('history'));
      historyAry.push(window.location.href);
      if (historyAry.length > 5) historyAry.shift();
      sessionStorage.setItem('history', JSON.stringify(historyAry));
    } else {
      sessionStorage.setItem('history', JSON.stringify([window.location.href]));
    }

    const historyData = JSON.parse(sessionStorage.getItem('history'));
    $('.js-back-to-works').on('click', (e) => {
      if (historyData.length > 1) {
        e.preventDefault();
        location.href = historyData[historyData.length - 2];
      }
    });

    /*
    $('[data-scroll-trigger]').each((i, e) => {
      this.scrollEffectManager.append($(e));
    });
    $('.wp-block-image').each((i, e) => {
      this.scrollEffectManager.append($(e));
    });

    $('[data-scroll-image]').each((i, e) => {
      this.scrollImageManager.append($(e));
    });
    */

    // this.checkPageApp();

    this.scrollableElement = null;
    let firefox = navigator.userAgent.match(/Firefox\/([0-9]+)\./);
    if ('scrollingElement' in document) {
      this.scrollableElement = document.scrollingElement;
    } else if (
      /*@cc_on!@*/ false ||
      (!!window.MSInputMethodContext && !!document.documentMode)
    ) {
      this.scrollableElement = document.documentElement;
    } else if (firefox && parseInt(firefox[1]) <= 47) {
      this.scrollableElement = document.documentElement;
    } else {
      this.scrollableElement = document.body;
    }

    this.$window
      .on('resize', () => {
        this.onWindowResize();
      })
      .on('scroll', () => {
        this.onWindowScroll();
      });
    this.onWindowResize();
  }
  clearPageApp() {
    $('body').css('pointer-events', 'none');
    clearTimeout(this.loaderTimeout);
    $('.Loading').removeClass('fadeout');
    $('.SpMenuButton').removeClass('SpMenuButton--open');
    $('.HeaderLogo').removeClass('HeaderLogo--spMenuShow');
    this.loader = null;
    this.scrollEffectManager.clear();
    this.scrollImageManager.clear();
    if (this.pageApp != undefined) {
      this.pageApp.destroy();
      this.pageApp = undefined;
    }
  }

  checkPageApp(namespace) {
    // console.log('checkPageApp', namespace);

    /*
    const namespace = $('[data-barba="container"]').attr(
      'data-barba-namespace'
    );
    */
    this.header.pageChange(namespace);

    if (namespace == 'home') {
      this.pageApp = new PageHome(this);
    } else if (
      namespace == 'contact' ||
      namespace == 'download' ||
      namespace == 'request'
    ) {
      this.pageApp = new PageContact(this);
    } else if (namespace == 'thanks') {
      this.pageApp = new PageThanks(this);
    } else if (namespace == 'works-detail' || namespace == 'blog-detail') {
      this.pageApp = new PageWorksDetail(this);
    } else if (namespace == 'service') {
      this.pageApp = new PageService(this);
    } else if (namespace == 'value') {
      this.pageApp = new PageValue(this);
    } else if (namespace == 'news') {
      this.pageApp = new PageNews(this);
    } else if (namespace == 'about') {
      this.pageApp = new PageValue(this);
    } else if (namespace == 'culture') {
      this.pageApp = new PageCulture(this);
    } else if (namespace == 'dmc-detail') {
      this.pageApp = new PageDmcDetail(this);
    } else if (namespace == 'brand') {
      this.pageApp = new PageBrand(this);
    } else if (namespace == 'people') {
      this.pageApp = new PagePeople(this);
    }

    this.stickyFooter.pageChange(namespace);
    $('body').css('pointer-events', 'auto');

    setTimeout(() => {
      if (this.pageApp != undefined) {
        this.pageApp.onLoadWindow();
      }
      $('[data-scroll-trigger]').each((i, e) => {
        this.scrollEffectManager.append($(e));
      });
      $('.wp-block-image').each((i, e) => {
        this.scrollEffectManager.append($(e));
      });

      $('[data-scroll-image]').each((i, e) => {
        this.scrollImageManager.append($(e));
      });
      this.onWindowResize();
      this.loader = new Loader();
      this.loaderTimeout = setTimeout(() => {
        $('.Loading').addClass('fadeout');
      }, 150);
    }, 100);
  }

  onLoadWindow() {
    /*
    if (this.pageApp != undefined) {
      this.pageApp.onLoadWindow();
    }
    */
  }

  scrollPage(val, isCancelTransition = false) {
    if (isCancelTransition) {
      $(this.scrollableElement)
        .stop(false)
        .scrollTop(val - $('.Header').height());
    } else {
      $(this.scrollableElement)
        .stop(false)
        .animate(
          { scrollTop: val - $('.Header').height() },
          1200,
          'easeInOutExpo'
        );
    }
  }

  onWindowResize() {
    // this.windowWidth = this.$window.width();
    // this.showHeight = this.$window.height();

    this.scrollEffectManager.onWindowResize();
    this.scrollImageManager.onWindowResize();

    this.onWindowScroll();

    if (this.pageApp != undefined) {
      this.pageApp.onWindowResize();
    }
  }

  onWindowScroll() {
    let scrollTop = this.$window.scrollTop();
    this.windowH = this.$window.height();
    this.header.update(scrollTop, this.windowH);

    this.scrollEffectManager.update(scrollTop);
    this.scrollImageManager.update(scrollTop);

    this.stickyFooter.update(scrollTop, this.windowH);

    if (this.pageApp != undefined) {
      this.pageApp.onWindowScroll();
    }
  }
}

let mainApp = undefined;

$('document').ready(() => {
  mainApp = new MainApp();
});

$(window).on('load', () => {
  /*
  if (location.hash == '') {
    $('html,body').stop().animate({ scrollTop: 0 }, '1');
  }
  */

  // 何故かonLoadの方が先に走る時がある挙動の対応
  if (mainApp) {
    new MouseStalker();
    mainApp.onLoadWindow();
  } else {
    const readyWaitInterval = setInterval(() => {
      if (mainApp) {
        clearInterval(readyWaitInterval);
        new MouseStalker();
        mainApp.onLoadWindow();
      }
    }, 1000 / 30);
  }
});

// SPA化する際に置き換え
function getNamespace() {
  const bodyClass = $('body').attr('class');
  if (bodyClass.indexOf('home') != -1) {
    return 'home';
  } else {
    return 'other';
  }
}
